import { useState, type ComponentPropsWithoutRef } from 'react';
import { RichTextEditor } from '@/components/RichTextEditor';
import { Editor } from '@tiptap/core';
import { Box, Grid } from '@simplywallst/ui-core';
import { useFlag } from '@/features/unleash';
import loadable from '@loadable/component';

interface Props
  extends Pick<
    ComponentPropsWithoutRef<typeof RichTextEditor>,
    | 'onSave'
    | 'onUpdate'
    | 'onError'
    | 'defaultContent'
    | 'isLoading'
    | 'isSuccess'
    | 'saveButtonText'
  > {
  errorMessage?: string;
  onDimissAlert?: () => void;
  defaultContent?: string;
}

const NarrativeEditorSuggestions = loadable(
  () => import('./components/NarrativeEditorSuggestions'),
  {
    resolveComponent: (component) => component.NarrativeEditorSuggestions,
  }
);

export const PublicNarrativeRichTextEditor = ({
  onUpdate,
  defaultContent,
}: Props) => {
  const flag = useFlag({ name: 'mono-narrative-editor-suggestions' });
  const areSuggestionsEnabled = flag.flagsReady && flag.enabled;

  const [editor, setEditor] = useState<Editor | null>(null);
  return (
    <Box position="relative" height="calc(100vh - 320px)">
      <Grid
        padding="x3"
        backgroundColor="noir"
        borderRadius="x0"
        borderRadiusLg="x2"
        height="100%"
      >
        <RichTextEditor
          isLoading={false}
          defaultContent={defaultContent}
          onUpdate={onUpdate}
          enableImages={false}
          onInit={(_conent, editorInstance) => setEditor(editorInstance)}
        />
      </Grid>

      {areSuggestionsEnabled && editor && (
        <NarrativeEditorSuggestions editor={editor} />
      )}
    </Box>
  );
};
